import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetToutiaoCollectionParams extends ActiomCommonParams {}

export interface GetToutiaoCollectionResult {
    id: string;
    collection_attr: {
        title: string;
        cover_image: {
            url: string;
            uri: string;
            width: number;
            height: number;
            mime_type: string;
        };
        item_status: number;
        visibility_level: number;
        create_time: string;
        suppress_reason: string;
        user_id: string;
    };
    collection_stat: {
        impression_count: string;
        go_detail_count: string;
        repin_count: string;
        forward_count: string;
    };
    menu_list: {
        show_delete: boolean;
        show_modify: boolean;
        show_hide: boolean;
        forbid_delete_reason: string;
        forbid_modify_reason: string;
        forbid_hide_reason: string;
    };
    sub_item_count: number;
    item_status_desc: string;
}

export type PublishAction = CommonAction<GetToutiaoCollectionParams, GetToutiaoCollectionResult[]>;

export const getToutiaoCollection: PublishAction = async (_task, params) => {
    const cookies = params.cookies ?? [];

    const http = new Http({
        headers: {
            cookie: cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
        },
    });

    const res = await http.api<{ code: number; data: GetToutiaoCollectionResult[]; total_count: number }>({
        method: "get",
        url: "https://mp.toutiao.com/mp/fe_api/collection/list",
        params: {
            page_num: 0,
            page_size: 100,
            need_sub_item_count: true,
        },
    });

    return success(res.code === 0 ? res.data : [], res.code === 0 ? "获取头条号合集成功！" : "获取头条号合集失败！");
};
